import React from 'react';

const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.jelarose.monalerte';
const text = { margin: 0, color: '#A0A0A0', lineHeight: 1.5 };

/**
 * Invitation à devenir amis (/ami#t=…). Avec l'app installée, le lien s'ouvre
 * directement dedans ; sinon cette page explique comment l'accepter. Le jeton
 * (#t=…) reste dans le navigateur.
 */
export default function FriendInvitePage() {
  return (
    <div style={{ minHeight: '100vh', background: '#0B0B0F', color: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ maxWidth: 480, width: '100%', background: '#15151C', border: '1px solid #2A2A35', borderRadius: 16, padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <h1 style={{ margin: 0, fontSize: 22, color: '#FACC15' }}>Invitation MonAlerte</h1>
        <p style={text}>
          Une personne vous invite à devenir amis sur MonAlerte : si l’un de vous lance une alerte, l’autre est prévenu
          tout de suite et peut suivre la situation.
        </p>
        <p style={text}>
          Pour accepter, installez l’application MonAlerte et connectez-vous, puis <strong>rouvrez ce lien depuis votre
          téléphone</strong> : il s’ouvrira dans l’application. Le lien est valable 7 jours et ne sert qu’une fois.
        </p>
        <a href={PLAY_STORE} style={{ textAlign: 'center', padding: 12, borderRadius: 10, background: '#FACC15', color: '#000', fontWeight: 700, textDecoration: 'none' }}>
          Installer MonAlerte
        </a>
      </div>
    </div>
  );
}
